import { createContext } from "react";

export const ShowStaffViewContext = createContext<boolean | undefined>(
  undefined
);
